import React,{ useState, useEffect }  from 'react';
import './summary.css'
import {getCallSummary } from '../../common/constants/api';

const CallSummary =({startDate,endDate,rmId,callsBy}) =>{
    const [SummaryData, setSummaryData] = useState([]);

    useEffect(() => {
       
        getCallSummary(startDate, endDate,rmId,callsBy)
          .then(data => {
            setSummaryData(data);
          })
          .catch(err => {
            console.log(err);
            setSummaryData([]);
          });
      }, [startDate,endDate,rmId,callsBy]);
  
return(
    
    <div className = 'flex summary'>
        <div className ='total_col'>
        <p>Total</p>
        </div>
        <div className =''>
        <p></p>
        </div>
        <div className ='location_col'> 
            <p></p>
        </div>
        <div className ='no_of_calls'> 
        <p>{SummaryData.total}</p>
        </div>

        <div className ='leads'>
            <p>{SummaryData.leads}</p>
        </div>
        <div className ='follow_up'>
       <p>{SummaryData.followUp}</p>
        </div>
        <div className ='not_interested'>
       <p>{SummaryData.notInterested}</p>
        </div>
        <div className ='log_in'>
      <p>{SummaryData.login}</p>
        </div>
    </div>
  
)

}
export default CallSummary